var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwtrIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.18 4.71006L21.08 3.81006L22.18 1.41006L19.62 2.26006C18.8046 1.49999 17.7346 1.072 16.62 1.06006C15.4273 1.0627 14.2842 1.53765 13.4409 2.381C12.5976 3.22434 12.1226 4.3674 12.12 5.56006V6.56006C8.57996 7.29006 5.48996 5.36006 2.61996 2.06006C2.11996 4.72673 2.61996 6.72673 4.11996 8.06006L0.829956 7.56006C0.957062 8.61925 1.4523 9.6001 2.22913 10.3312C3.00597 11.0624 4.01501 11.4973 5.07996 11.5601L2.32996 12.5601C3.32996 14.5601 5.14996 14.8701 7.57996 15.0601C5.59378 16.4147 3.23353 17.1141 0.829956 17.0601C13.59 22.7301 21.08 14.4001 21.08 7.06006V6.23006L23.18 4.71006Z",
    stroke: "#F5F5F5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwtrIcon);
export default __webpack_public_path__ + "static/media/twtr_icon.7cefa7b2a30b0b87d47f63fdb372e463.svg";
export { ForwardRef as ReactComponent };